import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../src/styles/index.css";
import DoctorLogin from "../components/DoctorLogin/DoctorLogin";
import CreateHealthDetail from "../components/HfrRegister/CreateHealthDeatail";

function AbdmLogin() {
  const [tabs, setTabs] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    localStorage.setItem("myPath", window.location.pathname);
    const token = searchParams.get("token");
    if (token) {
      setTabs(1);
    }
  }, [searchParams]);

  return (
    <>
      <div className='mx-auto w-11/12 max-w-7xl bg-gray-100 mt-4 pb-4'>
        {/* Container with a light bottom border */}
        <div className='flex justify-center gap-8 border-b border-gray-200'>
          {["Login", "Register Facility"].map((item, index) => (
            <button
              key={index}
              onClick={() => setTabs(index)}
              className={`relative px-4 py-4 text-lg sm:text-xl md:text-2xl transition-all duration-300 outline-none ${tabs === index
                  ? "text-[#0097DB] font-semibold "
                  : "text-gray-500 hover:text-gray-700 font-medium"
                }`}
            >
              {item}
              {/* The Blue Dash: Visible only when active */}
              {tabs === index && (
                <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#0097DB] rounded-t-md" />
              )}
            </button>
          ))}
        </div>

        <div className="mt-2">
          {tabs === 0 ? <DoctorLogin /> : <CreateHealthDetail />}
        </div>
      </div>
    </>
  );
}

export default AbdmLogin;